import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
import process from 'process';
import App from './App';

// Polyfills for Node globals required by bcryptjs in the browser
window.Buffer = window.Buffer || Buffer;
window.process = window.process || process;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
